import React, { ReactNode } from "react";
import { LinhaTabela } from "shared/components/table/LinhaTabela";
import { RegistroTabela } from "shared/components/table/RegistroTabela";
import { formatarValorMonetario, formatarDataString } from "shared/util/functions/formatacoesDeValores/FormatarValores";
import { CheckBox } from "shared/components/checkbox/CheckBox";
import { useGestaoCobrancaCadastroContext } from "../../../context/gestaoCobranca/GestaoCobrancaCadastroContext";
import { InadimplenciaDTO } from "types/dto/RegistroInadimplenciaDTO";
import { OpcoesSelecionaveisCheckBox } from "types/OpcoesSelecionaveisCheckBoxType";

interface RenderRowsProps {
  checkBoxClick: (id: number) => void;
  registros: InadimplenciaDTO[];
  opcaoSelecionadaCheckBox?: OpcoesSelecionaveisCheckBox;
}

export const RenderRowsInadimplencia: React.FC<RenderRowsProps> = (props) => {
  const { inadimplenciasSelecionadas, possuiPermissaoIniciarAcordo } = useGestaoCobrancaCadastroContext();

  const renderRegistros = (inadimplencias: InadimplenciaDTO[]): ReactNode => {
    return inadimplencias.map((inadimplencia, index) => {
      const isRegistroSelecionado = inadimplenciasSelecionadas.includes(inadimplencia.id);
      return (
        <LinhaTabela
          id={`id-registro-inadimplencias-${index}`}
          key={`key-registro-inadimplencias-${index}`}
          isSelecionada={isRegistroSelecionado || props.opcaoSelecionadaCheckBox === "TODAS_FILTRO"}
        >
          {possuiPermissaoIniciarAcordo && (
            <RegistroTabela
              isCheckBox
              id={`check-box-inadimplencias-${inadimplencia.id}`}
              key={`check-box-inadimplencias-${inadimplencia.id}`}
            >
              <CheckBox
                id={`check-box-${inadimplencia.id}`}
                disabled={props.opcaoSelecionadaCheckBox === "TODAS_FILTRO"}
                usarValidacaoParaFormulario={false}
                key={`check-box-${inadimplencia.id}`}
                checked={isRegistroSelecionado || props.opcaoSelecionadaCheckBox === "TODAS_FILTRO"}
                onChange={() => props.checkBoxClick(inadimplencia.id)}
              />
            </RegistroTabela>
          )}

          <RegistroTabela
            id={`nosso-numero-inadimplencias-${inadimplencia.id}`}
            key={`nosso-numero-inadimplencias-${inadimplencia.id}`}
          >
            <span>{inadimplencia.nossoNumero ? inadimplencia.nossoNumero : " - "}</span>
          </RegistroTabela>

          <RegistroTabela
            id={`dataVencimento-inadimplencia-${inadimplencia.id}`}
            key={`dataVencimento-inadimplencia-${inadimplencia.id}`}
          >
            <span>{formatarDataString(inadimplencia.dataVencimento)}</span>
          </RegistroTabela>

          <RegistroTabela
            id={`valor-inadimplencia-${inadimplencia.id}`}
            key={`valor-inadimplencia-${inadimplencia.id}`}
          >
            <span>{formatarValorMonetario(inadimplencia.total)}</span>
          </RegistroTabela>

          <RegistroTabela id={`atraso-${inadimplencia.id}`} key={`atraso-${inadimplencia.id}`}>
            <span>{inadimplencia.diasAtraso}</span>
          </RegistroTabela>

          <RegistroTabela
            id={`juros-inadimplencia-${inadimplencia.id}`}
            key={`juros-inadimplencia-${inadimplencia.id}`}
          >
            <span>{formatarValorMonetario(inadimplencia.totalJuros)}</span>
          </RegistroTabela>

          <RegistroTabela
            id={`multa-inadimplencia-${inadimplencia.id}`}
            key={`multa-inadimplencia-${inadimplencia.id}`}
          >
            <span>{formatarValorMonetario(inadimplencia.totalMulta)}</span>
          </RegistroTabela>

          <RegistroTabela
            id={`correcao-inadimplencia-${inadimplencia.id}`}
            key={`correcao-inadimplencia-${inadimplencia.id}`}
          >
            <span>{formatarValorMonetario(inadimplencia.totalCorrecao)}</span>
          </RegistroTabela>

          <RegistroTabela
            id={`honorario-inadimplencia-${inadimplencia.id}`}
            key={`honorario-inadimplencia-${inadimplencia.id}`}
          >
            <span>{formatarValorMonetario(inadimplencia.totalHonorario)}</span>
          </RegistroTabela>

          <RegistroTabela
            id={`total-inadimplencia-${inadimplencia.id}`}
            key={`total-inadimplencia-${inadimplencia.id}`}
          >
            <span>{formatarValorMonetario(inadimplencia.totalAtualizado)}</span>
          </RegistroTabela>
        </LinhaTabela>
      );
    });
  };

  return <>{props.registros.length > 0 && renderRegistros(props.registros)}</>;
};
